import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/auth'

const api = new ApiCore({
	index: true,
	url: url
})

api.index = (params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.validateAuthCode = (params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/validate`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
